// ReportTypes
export const ORDER_DETAIL = 'ORDER_DETAIL';
export const COUNTRY_COMPARISON = 'COUNTRY_COMPARISON';
export const BUYER_COMMENTS = 'BUYER_COMMENTS';
export const ORDERS_BY_LOT = 'ORDERS_BY_LOT';
export const ITEM_DEMAND_SUMMARY = 'ITEM_DEMAND_SUMMARY';
export const PRODUCT_SALES = 'PRODUCT_SALES';
export const RETURNED_PRODUCTS = 'RETURNED_PRODUCTS';
export const SHIPMENT_COUNT_BY_USER = 'SHIPMENT_COUNT_BY_USER';
export const SHIPMENTS_SHIPPED_ITEMS = 'SHIPMENTS_SHIPPED_ITEMS';
export const SHIPPING_COST = 'SHIPPING_COST';
export const SHIPPING_MANIFEST = 'SHIPPING_MANIFEST';
export const BATCH_DETAIL = 'BATCH_DETAIL';
export const ACCOUNT_BALANCE_HISTORY = 'ACCOUNT_BALANCE_HISTORY';
export const INVENTORY_LOW_STOCK_REPORT = 'INVENTORY_LOW_STOCK_REPORT';
export const INVENTORY_AUDIT_REPORT = 'INVENTORY_AUDIT_REPORT';
export const INVENTORY_OUT_OF_STOCK_SHIPMENTS = 'INVENTORY_OUT_OF_STOCK_SHIPMENTS';
export const INVENTORY_STATUS_REPORT = 'INVENTORY_STATUS_REPORT';

export const BILLING_REPORTS = 'BILLING_REPORTS';

export const HOTKEYS_REFERENCE_REPORT = 'HOTKEYS_REFERENCE_REPORT';
export const BARCODE_SCAN_ACTION_REPORT = 'BARCODE_SCAN_ACTION_REPORT';
export const BARCODE_SCAN_QUICK_REFERENCE_REPORT = 'BARCODE_SCAN_QUICK_REFERENCE_REPORT';

export const RAW_EXPORTS_CUSTOMERS = 'RAW_EXPORTS_CUSTOMERS';
export const RAW_EXPORTS_ORDERS = 'RAW_EXPORTS_ORDERS';
export const RAW_EXPORTS_SHIPPED_ORDERS = 'RAW_EXPORTS_SHIPPED_ORDERS-orders';
export const RAW_EXPORTS_SHIPPED_ITEMS = 'RAW_EXPORTS_SHIPPED_ITEMS';
export const RAW_EXPORTS_PRODUCT_ALIASES = 'RAW_EXPORTS_PRODUCT_ALIASES';

export const REPORTS = {
  orders: {
    links: {
      [ORDER_DETAIL]: 'OrderSummary',
      [COUNTRY_COMPARISON]: 'CountryComparison',
      [BUYER_COMMENTS]: 'BuyerComments',
      [ORDERS_BY_LOT]: 'OrderByLotExtract',
    },
    pages: [ORDER_DETAIL, COUNTRY_COMPARISON, BUYER_COMMENTS, ORDERS_BY_LOT],
  },
  products: {
    links: {
      [ITEM_DEMAND_SUMMARY]: 'ItemDemandReport',
      [PRODUCT_SALES]: 'ProductSales',
      [RETURNED_PRODUCTS]: 'ProductReturns',
    },
    pages: [ITEM_DEMAND_SUMMARY, PRODUCT_SALES, RETURNED_PRODUCTS],
  },
  shipments: {
    links: {
      [SHIPMENT_COUNT_BY_USER]: 'ShipmentCountReport',
      [SHIPMENTS_SHIPPED_ITEMS]: 'ItemsShipped',
      [SHIPPING_COST]: 'ShippingCosts',
      [SHIPPING_MANIFEST]: 'ShippingManifest',
      [BATCH_DETAIL]: 'BatchDetail',
    },
    pages: [SHIPMENT_COUNT_BY_USER, SHIPMENTS_SHIPPED_ITEMS, SHIPPING_COST, SHIPPING_MANIFEST, BATCH_DETAIL],
  },
  accounting: {
    links: {
      [ACCOUNT_BALANCE_HISTORY]: 'PostageTransactions',
    },
    pages: [ACCOUNT_BALANCE_HISTORY],
  },
  inventory: {
    links: {
      [INVENTORY_LOW_STOCK_REPORT]: 'InvLowStock',
      [INVENTORY_AUDIT_REPORT]: 'InvAuditReport',
      [INVENTORY_OUT_OF_STOCK_SHIPMENTS]: 'InvOutOfStockShipments',
      [INVENTORY_STATUS_REPORT]: 'InvStock',
    },
    pages: [INVENTORY_LOW_STOCK_REPORT, INVENTORY_AUDIT_REPORT, INVENTORY_OUT_OF_STOCK_SHIPMENTS, INVENTORY_STATUS_REPORT],
  },
  fulfilledByShipStation: {
    links: {
      [BILLING_REPORTS]: 'BillingReports',
    },
    pages: [BILLING_REPORTS],
  },
  hotkeysAndBarcodes: {
    links: {
      [HOTKEYS_REFERENCE_REPORT]: 'HotkeysReference',
      [BARCODE_SCAN_ACTION_REPORT]: 'BarcodeScanActionReport',
      [BARCODE_SCAN_QUICK_REFERENCE_REPORT]: 'BarcodeScanQuickReference',
    },
    pages: [HOTKEYS_REFERENCE_REPORT, BARCODE_SCAN_ACTION_REPORT, BARCODE_SCAN_QUICK_REFERENCE_REPORT],
  },
  exports: {
    links: {
      [RAW_EXPORTS_CUSTOMERS]: 'Customer',
      [RAW_EXPORTS_ORDERS]: 'OrderItemExtractReport',
      [RAW_EXPORTS_SHIPPED_ORDERS]: 'ShippingExtract',
      [RAW_EXPORTS_SHIPPED_ITEMS]: 'ShippingItemExtract',
      [RAW_EXPORTS_PRODUCT_ALIASES]: 'ProductAliasExtract',
    },
    pages: [RAW_EXPORTS_CUSTOMERS, RAW_EXPORTS_ORDERS, RAW_EXPORTS_SHIPPED_ORDERS, RAW_EXPORTS_SHIPPED_ITEMS, RAW_EXPORTS_PRODUCT_ALIASES],
  },
};

export const REPORTS_KEYS = Object.keys(REPORTS);
export const REPORTS_LINKS = REPORTS_KEYS.reduce((results, report) => ({ ...results, ...REPORTS[report].links }), {});
export const REPORTS_PAGES = REPORTS_KEYS.reduce((results, report) => [...results, ...REPORTS[report].pages], []);

export const ERROR_TYPE_GENERAL = 'ERROR_TYPE_GENERAL';
export const ERROR_TYPE_HTML_TOO_LARGE = 'ERROR_TYPE_HTML_TOO_LARGE';
export const DevExHtmlTooLargeException = 'DevExHtmlTooLargeException';
